<template>
    <div>
        <b-card-actions action-collapse title="House Amenity">
            <b-row>
                <b-col md="12">
                    <b-row class="font-weight-bold text-center border-bottom pb-2 mb-2">
                        <b-col cols="6" class="text-left"></b-col>
                        <b-col cols="3" class="text-center">Show on Site</b-col>
                        <b-col cols="3" class="text-center">Key Feature</b-col>
                    </b-row>

                    <div v-for="item in amenityOptions" :key="item.value" class="mb-2">
                        <b-row class="align-items-center">
                            <b-col cols="6">{{ item.text }}</b-col>

                            <b-col cols="3" class="text-center">
                                <b-form-checkbox
                                v-model="getAmenity(item.value).show_frontend"
                                :value="true"
                                :unchecked-value="false"
                                />
                            </b-col>

                            <b-col cols="3" class="text-center">
                                <b-form-checkbox
                                v-model="getAmenity(item.value).show_key_feature"
                                :value="true"
                                :unchecked-value="false"
                                />
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-card-actions>
    </div>
</template>

<script>
import { BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'

export default {
    components: {
        BCardActions, BRow, BCol, BFormCheckbox,
    },
    props: {
        form: { type: Object, required: true },
    },
    data() {
        return {
            amenityOptions: [],
        }
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale || 'en'
        },
        filteredAmenities() {
            return this.form.amenities.filter(a => a.show_frontend || a.show_key_feature)
        },
    },
    async created() {
        await this.fetchAmenityData()
        this.normalizeAmenityData()
    },
    methods: {
        async fetchAmenityData() {
            try {
                const queryParams = {
                    type_code: '2',
                    is_active: 1,
                    order_by: 'FIRST_LETTER ASC',
                }

                const { data } = await axios.post('facility/v1/lists', queryParams)

                this.amenityOptions = data.data.map(item => ({
                    text: item.name[this.currentLocale] || item.name['en'],
                    value: Number(item.id),
                }))

                if (!Array.isArray(this.form.amenities)) {
                    this.form.amenities = []
                }

                this.syncAmenities()
            } catch (err) {
                console.error('Error fetching amenity list:', err)
            }
        },

        // Ensure all amenities exist in form.amenities
        syncAmenities() {
            const existingAmenities = this.form.amenities
            this.amenityOptions.forEach(item => {
                const exists = existingAmenities.find(a => Number(a.id) === Number(item.value))
                if (!exists) {
                    this.form.amenities.push({
                        id: Number(item.value),
                        show_frontend: false,
                        show_key_feature: false,
                    })
                }
            })
        },
        normalizeAmenityData() {
            this.form.amenities = this.form.amenities.map(a => ({
                id: Number(a.id),
                show_frontend: Boolean(a.show_frontend),
                show_key_feature: Boolean(a.show_key_feature),
            }))
        },
        getAmenity(id) {
            id = Number(id)
            let found = this.form.amenities.find(a => Number(a.id) === id)
            if (!found) {
                found = { id, show_frontend: false, show_key_feature: false }
                this.form.amenities.push(found)
            }
            return found
        },
        async saveForm() {
            try {
                const payload = {
                    ...this.form,
                    amenities: this.filteredAmenities.map(a => ({
                        id: a.id,
                        show_frontend: a.show_frontend ? 1 : 0,
                        show_key_feature: a.show_key_feature ? 1 : 0,
                    })),
                }

                await axios.post('/your/api/endpoint', payload)
                this.$toast.success('Saved successfully!')
            } catch (err) {
                console.error(err)
                this.$toast.error('Failed to save.')
            }
        },
    },
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #dee2e6;
}
</style>